import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faFishFins, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const Fishbone = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();

  const [userId, setUserId] = useState(authState.user._id);
  const [rcaBookStatus, setRcaBookStatus] = useState(false);

  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const { fishboneId } = useParams();
  const mode = fishboneId === undefined ? "add" : "update";
  const [isUpdateLock, setIsUpdateLock] = useState(false);
  const [error, setError] = useState(null);


  const [formData, setFormData] = useState({
    userId: authState.user._id,
    createdBy: authState.user._id,
    dateCreated: new Date(),
    problemTitle: '',
    problem: {
      short: '',
      description: '',
      remarks: ''
    },
    cat1: {
      name: 'Manpower',
      shortcode: 'Manpower',
      causes: [
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
      ]
    },
    cat2: {
      name: 'Machine',
      shortcode: 'Machine',
      causes: [
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
      ]
    },
    cat3: {
      name: 'Process',
      shortcode: 'Process',
      causes: [
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
      ]
    },
    cat4: {
      name: 'Material',
      shortcode: 'Material',
      causes: [
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
      ]
    },
    cat5: {
      name: 'Nature',
      shortcode: 'Nature',
      causes: [
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
      ]
    },
    cat6: {
      name: 'Measurement',
      shortcode: 'Measurement',
      causes: [
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
        { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
      ]
    },
    teamCode: '',
    projectCode: '',
    processCode: '',
    locationCode: '',
    isActive: true,
    isDeleted: false,
    isExample: false,
    category: '',
  });


  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    const config = { 
      url: `/mybooks/think5whysbookbuyingstatus`, 
      method: "post", 
      headers: { Authorization: authState.token },
      data: {userId: userId} 
    };

    fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log("response for update",data);
        setRcaBookStatus(true);
    })
    .catch((error) => {
      console.error("Error fetching Think5Whys Main BOK status:", error);
      setError("Error fetching Think5Whys Main BOK status");
    });

  }, [mode, authState, userId, fetchData, setRcaBookStatus]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/fishbone/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {fishboneId: fishboneId}
      };
      // console.log("Getting Data for Update here",config);
      // console.log("Existing formData",formData);

      fetchData(config, { showSuccessToast: false }).then((data) => {
        // console.log("response for update - ",data.fishbone);
        // setFishbone(data.fishbone);
        // console.log("response for update - ", data.fishbone);

        setFormData({
          userId: data.fishbone.userId,
          createdBy: data.fishbone.createdBy,
          dateCreated: new Date(data.fishbone.dateCreated),
          problemTitle: data.fishbone.problemTitle,
          problem: {
            short: data.fishbone.problem.short,
            description: data.fishbone.problem.description,
            remarks: data.fishbone.problem.remarks
          },
          cat1: data.fishbone.cat1,
          cat2: data.fishbone.cat2,
          cat3: data.fishbone.cat3,
          cat4: data.fishbone.cat4,
          cat5: data.fishbone.cat5,
          cat6: data.fishbone.cat6,
          teamCode: data.fishbone.teamCode,
          projectCode: data.fishbone.projectCode,
          processCode: data.fishbone.processCode,
          locationCode: data.fishbone.locationCode,
          isActive: data.fishbone.isActive,
          isDeleted: data.fishbone.isDeleted,
          isExample: data.fishbone.isExample,
          category: data.fishbone.category,
        });
      })
      .catch((error) => {
        console.error("Error fetching Fishbone data:", error);
        setError("Error fetching Fishbone data");
      });
    }
  }, [mode, authState, fishboneId, fetchData, setFormData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleProblemChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      problem: {
        ...prevFormData.problem,
        [name]: value
      }
    }));
  };

  const handleReset = e => {
    e.preventDefault();
    setFormData({
      userId: authState.user._id,
      createdBy: authState.user._id,
      dateCreated: new Date(),
      problemTitle: '',
      problem: {
        short: '',
        description: '',
        remarks: ''
      },
      cat1: {
        name: '',
        shortcode: '',
        causes: [
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
        ]
      },
      cat2: {
        name: '',
        shortcode: '',
        causes: [
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
        ]
      },
      cat3: {
        name: '',
        shortcode: '',
        causes: [
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
        ]
      },
      cat4: {
        name: '',
        shortcode: '',
        causes: [
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
        ]
      },
      cat5: {
        name: '',
        shortcode: '',
        causes: [
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
        ]
      },
      cat6: {
        name: '',
        shortcode: '',
        causes: [
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' },
          { name: '', shortcode: '', details: '', count: '', weightage: '', solution: '', remarks: '' }
        ]
      },
      teamCode: '',
      projectCode: '',
      processCode: '',
      locationCode: '',
      isActive: true,
      isDeleted: false,
      isExample: false,
      category: 'Undefined',
    });
  };

  const handleCategoryChange = (catIndex, causeIndex, e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const updatedCauses = prevFormData[`cat${catIndex}`].causes.map((cause, index) =>
        index === causeIndex ? { ...cause, [name]: value } : cause
      );
      return {
        ...prevFormData,
        [`cat${catIndex}`]: {
          ...prevFormData[`cat${catIndex}`],
          causes: updatedCauses
        }
      };
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ", error, " no. of error", Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ", setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/fishbone", 
        method: "post",
        data: {formData: formData}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data ",JSON.stringify(formData, null, 2), " User ",authState.user._id);


      fetchData(config)
        .then(() => {
          // console.log("Posted Successfully");
          navigate("/fishbones");
        })
        .catch((error) => {
          // console.log("Error posting fishbone");
          console.error("Error posting fishbone:", error);
          setError("Error posting fishbone");
        });
    }
    else {
      const config = { 
        url: `/fishbone/${fishboneId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for "+mode+" Fishbone",config);

      fetchData(config).then(() => {
        navigate("/fishbones");
      })
      .catch((error) => {
        console.error("Error updating Fishbone:", error);
        setError("Error updating Fishbone");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.problemTitle) {
      errors.purpose = "Title is required";
    } else if (formData.problemTitle.length > 100) {
      errors.title = "Title cannot exceed 100 characters";
    }
    if (!formData.problem.short) {
      errors.taskDate = "Problem short code is required";
    } else if (formData.problem.short.length > 20) {
      errors.title = "Title cannot exceed 20 characters";
    }
    if (!formData.problem.description) {
      errors.title = "Problem Statement is required";
    } else if (formData.problem.description.length > 2000) {
      errors.title = "Problem Statement cannot exceed 2000 characters";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const [visibleCategory, setVisibleCategory] = useState(null);

  const handleCategoryNameChange = (catIndex, e) => {
    const updatedCategory = { ...formData[`cat${catIndex}`], [e.target.name]: e.target.value };
    setFormData({ ...formData, [`cat${catIndex}`]: updatedCategory });
  };

  const handleButtonClick = (catIndex) => {
    setVisibleCategory(visibleCategory === catIndex ? null : catIndex);
  };

  const toggleCategoryVisibility = (catIndex) => {
    setVisibleCategory(visibleCategory === catIndex ? null : catIndex);
  }; 

  const [visibleCause, setVisibleCause] = useState({});

  const toggleCauseVisibility = (catIndex, causeIndex) => {
    setVisibleCause((prev) => ({
      ...prev,
      [catIndex]: prev[catIndex] === causeIndex ? null : causeIndex,
    }));
  };

  const [inputTeamCodes, setInputTeamCodes]=useState(false);
  const handleInputTeamCodes = (e) => {
    setInputTeamCodes(e.target.checked);
  };

  const handleExampleClick = (e) => {
    navigate("/fishbone-example");
  };

  const handleAboutClick = (e) => {
    navigate("/fishbone-about");
  };


  return (
    <div className='bg-black [&_p]:text-white'>
        <div className='border-b border-blue-400 mb-2'>
          <h2 className='text-xl lg:text-2xl py-2 px-4 font-bold text-yellow-200 text-start mb-2'>Fishbone Entry Form</h2>
        </div>
        <div className='m-auto my-2 p-2 text-white text-sm shadow-md rounded-md w-full'>
          <form onSubmit={handleSubmit}>
            <div className='flex justify-center'>
                <h2 
                  className="ml-2 text-lg lg:text-xl text-yellow-200">
                  {mode === "add" ? "Add New Fishbone" : "Edit Fishbone"}
                </h2>
            </div>
            <div className="border-container-gray ml-8 text-sm">
              <p className="text-white text-sm py-2">Think5Whys Main BOK Status: {rcaBookStatus ? "Purchased": "Not Purchased Yet"}</p>
              <div className='flex justify-left flex-row'>  
                <button
                  type="button"
                  className='text-sm lg:text-m mr-2 lg:w-64 bg-blue-700'
                  onClick={handleExampleClick}
                >
                  View Example
                </button>
                <button
                  type="button"
                  className='text-sm lg:text-m ml-2 lg:w-64 bg-blue-700'
                  onClick={handleAboutClick}
                >
                  About Fishbone & Why Use It?
                </button>                
              </div>
              <div className='flex flex-col text-sm'>
                <label>Problem Title / Name / Heading:</label>
                <input 
                  className='h-8 text-black' 
                  type="text" 
                  name="problemTitle" 
                  style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    width: '75%',
                    boxSizing: 'border-box',
                  }} 
                  value={formData.problemTitle} onChange={handleChange} 
                />
                <label>Problem Short Name for Fishbone Diagram:</label>
                <input 
                  className='h-8 text-black' 
                  type="text" 
                  name="short" 
                  style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    width: '30%',
                    boxSizing: 'border-box',
                  }} 
                  value={formData.problem.short} onChange={handleProblemChange} 
                />
                <label>Problem Statement Description:</label>
                <textarea 
                  name="description" 
                  value={formData.problem.description} 
                  onChange={handleProblemChange}
                  maxLength="2000"
                  style={{
                    border: '1px solid #ccc',
                    padding: '2px',
                    backgroundColor: '#f0f0f0', 
                    color: '#000000',
                    maxWidth: '650px', 
                    maxHeight: '150px' 
                  }}
                >
                </textarea>
              </div>
            </div>
            <div className='flex flex-row justify-center mt-2'>
              <p className='h-10 text-yellow-200 text-lg'>Select Category To Input Details</p>
            </div>
            <div className='flex flex-row justify-center mt-2'>
              {['C1', 'C2', 'C3', 'C4', 'C5', 'C6'].map((label, index) => (
                <button
                  type="button"
                  className='ml-2 mr-2 w-10 bg-cyan-700'
                  key={index}
                  onClick={() => handleButtonClick(index + 1)}
                >
                  {label}
                </button>
              ))}
            </div>
            {[1, 2, 3, 4, 5, 6].map((catIndex) => (
              visibleCategory === catIndex && (
                <div className="border-container-gray ml-8 text-sm">
                  <div className='text-sm' key={catIndex}>
                    <h3 className='text-lg mb-2'>Category {catIndex}</h3>
                    <div className='border-container-gray flex flex-col mb-2 text-sm'>
                      <label className='text-sm'>Category Name:</label>
                      <input
                        type="text"
                        name="name"
                        className='h-8 w-10 text-white'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '30%',
                          boxSizing: 'border-box',
                        }} 
                        value={formData[`cat${catIndex}`].name}
                        disabled={true}
                        onChange={(e) => handleCategoryNameChange(catIndex, e)}
                      />
                      <label className='text-sm'>Category Shortcode for Fishbone Diagram:</label>
                      <input
                        type="text"
                        name="shortcode"
                        className='h-8 w-10 text-white'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '15%',
                          boxSizing: 'border-box',
                        }} 
                        value={formData[`cat${catIndex}`].shortcode}
                        disabled={true}
                        onChange={(e) => handleCategoryNameChange(catIndex, e)}
                      />
                    </div>
                    {/* Cause Buttons */}
                    <div className='flex flex-row justify-center mt-2'>
                        <p>Select Cause To Input Details</p>
                    </div>
                    <div className='flex flex-row justify-center mt-2'>
                      {[0, 1].map((causeIndex) => (
                        <button
                          type="button"
                          className='w-20 mr-2 ml-2 bg-teal-600'
                          onClick={() => toggleCauseVisibility(catIndex, causeIndex)}
                          key={`cause-button-${catIndex}-${causeIndex}`}
                        >
                          Cause{causeIndex + 1}
                        </button>
                      ))}
                    </div>
                    {[0, 1].map((causeIndex) => (
                      visibleCause[catIndex] === causeIndex && (
                        <div className="border-container-gray ml-8 text-sm">
                          <div className='text-sm' key={causeIndex}>
                            <h4>Cause {causeIndex + 1}</h4>
                            <div className='flex flex-col'>
                              <label>Cause Headline / Title / Name:</label>
                              <input
                                type="text"
                                name="name"
                                className='h-8 text-black'
                                style={{
                                  border: '1px solid #ccc',
                                  padding: '8px',
                                  width: '75%',
                                  boxSizing: 'border-box',
                                }} 
                                value={formData[`cat${catIndex}`].causes[causeIndex].name}
                                onChange={(e) => handleCategoryChange(catIndex, causeIndex, e)}
                              />
                              <label>Cause Short Name for Fishbone Diagram:</label>
                              <input
                                type="text"
                                name="shortcode"
                                className='h-8 text-black'
                                style={{
                                  border: '1px solid #ccc',
                                  padding: '8px',
                                  width: '15%',
                                  boxSizing: 'border-box',
                                }} 
                                value={formData[`cat${catIndex}`].causes[causeIndex].shortcode}
                                onChange={(e) => handleCategoryChange(catIndex, causeIndex, e)}
                              />
                              <label>Details:</label>
                              <textarea
                                name="details"
                                value={formData[`cat${catIndex}`].causes[causeIndex].details}
                                maxLength="2000"
                                style={{
                                  border: '1px solid #ccc',
                                  padding: '2px',
                                  backgroundColor: '#f0f0f0', 
                                  color: '#000000',
                                  maxWidth: '650px', 
                                  maxHeight: '100px' 
                                }}
                                onChange={(e) => handleCategoryChange(catIndex, causeIndex, e)}
                              ></textarea>
                              <label>Cause Count:</label>
                              <input
                                type="number"
                                name="count"
                                className='h-8 text-black'
                                style={{
                                  border: '1px solid #ccc',
                                  padding: '8px',
                                  width: '80px',
                                  boxSizing: 'border-box',
                                }} 
                                value={formData[`cat${catIndex}`].causes[causeIndex].count}
                                onChange={(e) => handleCategoryChange(catIndex, causeIndex, e)}
                              />
                              <label>Cause Weightage:</label>
                              <input
                                type="number"
                                name="weightage"
                                className='h-8 text-black'
                                style={{
                                  border: '1px solid #ccc',
                                  padding: '8px',
                                  width: '80px',
                                  boxSizing: 'border-box',
                                }} 
                                value={formData[`cat${catIndex}`].causes[causeIndex].weightage}
                                onChange={(e) => handleCategoryChange(catIndex, causeIndex, e)}
                              />
                              <label>Solution:</label>
                              <textarea
                                name="solution"
                                value={formData[`cat${catIndex}`].causes[causeIndex].solution}
                                maxLength="2000"
                                style={{
                                  border: '1px solid #ccc',
                                  padding: '2px',
                                  backgroundColor: '#f0f0f0', 
                                  color: '#000000',
                                  maxWidth: '650px', 
                                  maxHeight: '100px' 
                                }}
                                onChange={(e) => handleCategoryChange(catIndex, causeIndex, e)}
                              ></textarea>
                              <label>Remarks:</label>
                              <textarea
                                name="remarks"
                                value={formData[`cat${catIndex}`].causes[causeIndex].remarks}
                                maxLength="2000"
                                style={{
                                  border: '1px solid #ccc',
                                  padding: '2px',
                                  backgroundColor: '#f0f0f0', 
                                  color: '#000000',
                                  maxWidth: '650px', 
                                  maxHeight: '100px' 
                                }}
                                onChange={(e) => handleCategoryChange(catIndex, causeIndex, e)}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      )
                    ))}
                  </div>
                </div>
              )
            ))}
            <div className="border-container flex flex-col text-m text-sm">
              <label>Problem Category:</label>
                  <input 
                    className='h-8 text-black' 
                    type="text" 
                    name="category" 
                    style={{
                      border: '1px solid #ccc',
                      padding: '8px',
                      width: '150px',
                      boxSizing: 'border-box',
                    }} 
                    value={formData.category} 
                    onChange={handleChange} 
                  />
              <label>Problem Remarks:</label>
              <textarea 
                name="remarks" 
                value={formData.problem.remarks} 
                maxLength="2000"
                style={{
                  border: '1px solid #ccc',
                  padding: '2px',
                  backgroundColor: '#f0f0f0', 
                  color: '#000000',
                  maxWidth: '650px', 
                  maxHeight: '150px' 
                }}
                onChange={handleProblemChange}
                >
              </textarea>
            </div>
            <div className="mb-2 text-sm mt-2">
              <label>
                <input className='ml-4 mr-4' type="checkbox" checked={inputTeamCodes} onChange={handleInputTeamCodes} />
                View / Associate Team, Project, Process & Location
              </label>
            </div>
            {inputTeamCodes && ( 
              <>
              <div className="border-container-gray ml-8 text-sm">
                <div className='flex flex-col text-sm'>
                  <label>Team Code:</label>
                  <input 
                    className='h-8 text-black' 
                    type="text" 
                    name="teamCode" 
                    style={{
                      border: '1px solid #ccc',
                      padding: '8px',
                      width: '150px',
                      boxSizing: 'border-box',
                    }} 
                    value={formData.teamCode} onChange={handleChange} 
                  />
                  <label>Project Code:</label>
                  <input 
                    className='h-8 text-black' 
                    type="text" 
                    name="projectCode" 
                    style={{
                      border: '1px solid #ccc',
                      padding: '8px',
                      width: '150px',
                      boxSizing: 'border-box',
                    }} 
                    value={formData.projectCode} 
                    onChange={handleChange} 
                  />
                  <label>Process Code:</label>
                  <input 
                    className='h-8 text-black' 
                    type="text" 
                    name="processCode" 
                    style={{
                      border: '1px solid #ccc',
                      padding: '8px',
                      width: '150px',
                      boxSizing: 'border-box',
                    }} 
                    value={formData.processCode} 
                    onChange={handleChange} 
                  />
                  <label>Location Code:</label>
                  <input 
                    className='h-8 text-black' 
                    type="text" 
                    name="locationCode" 
                    style={{
                      border: '1px solid #ccc',
                      padding: '8px',
                      width: '150px',
                      boxSizing: 'border-box',
                    }} 
                    value={formData.locationCode} onChange={handleChange} 
                  />
                </div>
              </div>
              </>
            )}
            <div className="border-container flex flex-col justify-center">
                <div className="flex justify-center">
                  {Object.keys(formErrors).length > 0 && (
                    <div className="form-errors text-red-300 justify-center items-center">
                      {Object.keys(formErrors).map((key) => (
                        <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                      ))}
                    </div>
                  )}
                </div>

                { mode == 'update' && (
                    <div>
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={isUpdateLock} 
                        onChange={(e) => setIsUpdateLock(e.target.checked)} 
                      />
                      {isUpdateLock ? "Enable Update" : "Disable Update"}
                    </label>
                  </div>
                )}
                <div className="flex justify-left">
                  <button 
                    className='bg-blue-600 text-white px-4 py-2 w-40 font-medium hover:bg-primary-dark' 
                    disabled={isUpdateLock && mode==="update"}
                    onClick={handleSubmit}>
                      {mode === "add" ? "Add New" : "Update"}
                  </button>
                  <button 
                    className='ml-4 bg-red-500 text-white w-40 px-4 py-2 font-medium' 
                    onClick={() => navigate("/fishbones")}>
                      Cancel
                  </button>
                  {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>}
                </div>
              </div>
          </form>
        </div>
        <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
          <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/about-us" className="hover:text-teal-300">About</Link>
              <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
              <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
              <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
            </div>
          </div>
        </footer>          
    </div>
  );
};

export default Fishbone;
